import { BrowserNames } from "../../../types";
import { useTranslationsContext } from "../../../contexts/TranslationsContext";
import { detectBrowser } from "../../../helpers";

import chrSettingsDe from "../../../assets/photos/chr-settings-de.png";
import frxSettingsDe from "../../../assets/photos/frx-settings-de.png";
import sriSettingsDe from "../../../assets/photos/sri-settings-de.png";

function StepTwo(): JSX.Element {
  const { translation } = useTranslationsContext();
  const browser: BrowserNames = detectBrowser();

  const textMap: Record<string, string> = {
    [BrowserNames.CHROME]: translation.INSTALL_APP_STEP_2_CHROME.defaultMessage,
    [BrowserNames.FIREFOX]: translation.INSTALL_APP_STEP_2_FIREFOX.defaultMessage,
    [BrowserNames.SAFARI]: translation.INSTALL_APP_STEP_2_SAFARI.defaultMessage,
  };

  const imgMap: Record<string, { src: string; className: string }> = {
    [BrowserNames.CHROME]: { src: chrSettingsDe, className: "chr-settings" },
    [BrowserNames.FIREFOX]: { src: frxSettingsDe, className: "frx-settings" },
    [BrowserNames.SAFARI]: { src: sriSettingsDe, className: "sri-settings" },
  };

  const text = textMap[browser];
  const img = imgMap[browser];

  if (!text || !img) return <></>;

  return (
    <div className="ath-step-content">
      <span className="ath-step-number">2</span>
      <p className="ath-step-text">{text}</p>
      <div className="ath-img-card">
        <img className={img.className} src={img.src} alt="Step 2" />
      </div>
    </div>
  );
}

export default StepTwo;
